export interface TipoVeiculoModel {
    valor: string;
    texto: string;
}

export const TIPOS_VEICULO: TipoVeiculoModel[] = [
    { valor: "LEVE", texto: "Leve" },
    { valor: "UTILITARIO", texto: "Utilitário" },
    { valor: "PESADO", texto: "Pesado" },
    { valor: "ULTRA_PESADO", texto: "Extra pesado" },
]